<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: [
    'chartData',
    'chartId',
    'datasetIdKey',
    'plugins',
    'cssClasses',
    'styles',
    'width',
    'height',
  ],
  data(){
    return {
      chartOptions: {
        // indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }
}

</script>

<style lang="css" scoped>
</style>
